// extracted by mini-css-extract-plugin
export default {"content":"EventOfflineDialog_content__Dmr2O","list":"EventOfflineDialog_list__UhBH-"};